import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d01eb2f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-indicator" }
const _hoisted_2 = { class: "container-indicator__title" }
const _hoisted_3 = { class: "container-indicator__block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Норма", -1))
const _hoisted_5 = { class: "container-indicator__indicator" }
const _hoisted_6 = { class: "container-indicator__block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Факт", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isPrice)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.norm.toLocaleString('ru-RU')) + " ₸", 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.norm), 1)
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", {
        class: _normalizeClass(["container-indicator__indicator", { 'indicator--red': _ctx.isExcess, 'indicator--green': _ctx.isPassed }])
      }, [
        (_ctx.isPrice)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.fact.toLocaleString('ru-RU')) + " ₸", 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.fact), 1)
            ], 64))
      ], 2)
    ])
  ]))
}